import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbImageBreakdownInnerBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`image-breakdwown-inner ${props.attributes.className ? props.attributes.className : ''} ${classes.imageBreakdownInner} ${classes.imageBreakdownInnerTheme}`}>
        {blocks.map((block) => {
            return block;
        })}
    </div>
};

export const CgbImageBreakdownInnerBlockFragment = graphql`
  fragment CgbImageBreakdownInnerBlock on WpBlock {
    ... on WpCgbImageBreakdownInnerBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbImageBreakdownInnerBlockPreview = `
    ... on CgbImageBreakdownInnerBlock {
        name
        attributes {
            className
        }
    }
`;